import { useEffect, useState, type FC } from 'react';
import { LuCheck, LuChevronRight, LuInbox, LuUndo2 } from 'react-icons/lu';
import BrikAgente from './BrikAgente';
import './BrikFala.css';

/**
 * O Brik se apresenta (07/10/2026, desenho da Home, seção 6). Aparece uma vez por
 * pessoa, no lugar da Home; no lançamento, todo mundo vê, inclusive quem já usa o
 * sistema. A marca de "já viu" fica no servidor, então não volta em outro navegador.
 *
 * "Faço o que você me pedir", e não "faço por você": o Brik não oferece ação sem
 * pedido (decisão de 07/10).
 */
const BrikApresentacao: FC<{
    nome: string;
    onComecar: () => void;
    celular?: boolean;
}> = ({ nome, onComecar, celular = false }) => {
    /* Chega com um pulinho e depois fica vivo, de olho aberto, piscando e olhando
       em volta, como no balão da Home (07/10). */
    const [chegando, setChegando] = useState(true);
    useEffect(() => {
        const t = setTimeout(() => setChegando(false), 1000);
        return () => clearTimeout(t);
    }, []);

    return (
        <div className="hc-ap">
            <BrikAgente tamanho="grande" px={celular ? 88 : 112} estado={chegando ? 'feito' : 'repouso'} vivo />
            <h1 className="hc-ap-tt">Oi{nome ? `, ${nome}` : ''}. Eu sou o Brik AI.</h1>
            <p className="hc-ap-p">
                O assistente do seu Brik CRM. Pode me pedir em uma frase, do jeito que você pediria a alguém do time.
            </p>
            <ul className="hc-ap-lista">
                <li>
                    <span className="hc-ap-ic"><LuInbox size={16} /></span>
                    <span>Quando você chegar, eu já vou ter olhado o que entrou, o que venceu e o que parou.</span>
                </li>
                <li>
                    <span className="hc-ap-ic"><LuCheck size={16} /></span>
                    <span>Faço o que você me pedir: anoto, crio e adio tarefa, movo etapa, marco reunião.</span>
                </li>
                <li>
                    <span className="hc-ap-ic"><LuUndo2 size={16} /></span>
                    <span>Tudo o que eu faço tem desfazer. O que é sério, eu pergunto antes.</span>
                </li>
            </ul>
            <button type="button" className="hc-ap-btn" onClick={onComecar} autoFocus>
                Vamos começar <LuChevronRight size={14} />
            </button>
        </div>
    );
};

export default BrikApresentacao;
